import { mk_widget, IOWidget } from 'widgets-for-react'
import * as React from 'react'
import { Helmet } from "react-helmet";
import { t } from 'i18next';
import { PublicSiteState } from '../../public_site.main.mod';

export const notfound_page: IOWidget<PublicSiteState, never> = (public_state: PublicSiteState) => {
  return mk_widget({
    run: o => <>
      <Helmet>
        <title>404 | {t('404.title')}</title>
        <meta property="og:description" content={"404.description"} />
      </Helmet>
      <main className="main main--404">
        <div className="error-wrapper">
          <header className="page-header ph ph--page ph--secondary">
            <div className="ph__outer container">
              <div className="ph__inner">
                <div className="ph__content content">
                  <div className="ph__header">
                    <h1 className="ph__title typo--xl">{t('404.title')}</h1>
                    <p className="ph__intro">{t('404.description')}</p>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </main>
    </>
  })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/error_page.mod.tsx